export const TOTAL_DATA_DISPLAY = 10
export const DEFAULT_CHAIN = 56
